import authModule from "./AuthModule";
import { getSharePointBaseUrl } from "../src/taskpane/services/GraphService";
import { IAuthAccount } from "../src/taskpane/interfaces/IAuthTokenResultDto";
import { UserLicenseTypeEnum } from "../src/taskpane/components/enums/userLicenseTypeEnum";
import { IUserProfile } from "../src/taskpane/interfaces/IUserProfile";
import { logger } from "./logger";
import { apiGetUserLicense, apiGetUserProfile } from "../src/taskpane/services/ApiService";
import { getModeDisplayText, ModeEnum } from "../src/taskpane/components/enums/modeEnum";
import { getHost, getPlatformInit } from "../src/taskpane/styles/mobileStyles";

const UserSPScopeSuffix = "/AllSites.Manage";

export class UserModule {

    static async getUserSharePointBaseUrl(): Promise<string> {
        let spBaseUrl: string = localStorage?.getItem("spBaseUrl");
        if (!spBaseUrl) {
            spBaseUrl = await getSharePointBaseUrl(await authModule.getGraphAccessToken());
            if (spBaseUrl) {
                localStorage?.setItem("spBaseUrl", spBaseUrl);
            }
        }
        return spBaseUrl;
    }

    static async getUserSharePointScope(): Promise<string[]> {
        const spBaseUrl: string = await UserModule.getUserSharePointBaseUrl();
        const spScope: string[] = [spBaseUrl + UserSPScopeSuffix];
        return spScope;
    }

    static getUserLicense = async (userAccount: IAuthAccount): Promise<UserLicenseTypeEnum> => {
        try {
            const licenseType = await apiGetUserLicense(userAccount);
            return licenseType;
        } catch (error) {
            logger(error, "UserModule.ts (getUserLicense)");
        }
        return UserLicenseTypeEnum.Expired;
    }

    static getUserProfile = async (userAccount: IAuthAccount, mode: ModeEnum): Promise<IUserProfile> => {
        try {
            const host = getHost();
            const platform = getPlatformInit();

            let appContext: string = getModeDisplayText(mode);
            if (host) {
                appContext += ` - ${host}`;
            }
            if (platform) {
                appContext += ` - ${platform}`;
            }

            return await apiGetUserProfile(userAccount, appContext);
        } catch (error) {
            logger(error, "UserModule.ts (getUserProfile)");
            return null;
        }
    }
}